import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
    COMPRESS_IMAGE
} from "./type";


export const imageCompressUrl = (file, extension) => async (dispatch) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('extension', extension);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    };
    const res = await callWebService(
        callTypes.post,
        formData,
        Config.imageCompression.compressImage,
        config
      );
      
      if (res) {
        const { data } = res;
        dispatch({ type: COMPRESS_IMAGE, payload: data.response.data });
        return data.response.data;
      }
};